(() => {
  if (window.__fjMiniCartBridge) {
    return;
  }

  window.__fjMiniCartBridge = true;
  window.fjMiniCartViewCartHandlerInstalled = true;

  document.documentElement.addEventListener('cart:refresh', event => {
    const detail = event.detail;

    if (detail?.cart?.sections?.['mini-cart']) {
      detail.replacementDelay = 1;
    }
  }, true);

  document.addEventListener('click', event => {
    const clickedElement = event.target instanceof Element ? event.target : null;
    const viewCartLink = clickedElement?.closest('.cart-notification__view-cart');
    const cartDrawer = document.getElementById('mini-cart');

    if (!viewCartLink || !cartDrawer) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();

    const notification = viewCartLink.closest('cart-notification');
    const sourceDrawer = viewCartLink.closest('.drawer');

    const openCart = () => {
      const currentCartDrawer = document.getElementById('mini-cart');

      if (!currentCartDrawer) {
        return;
      }

      currentCartDrawer.nextReplacementDelay = 0;

      try {
        currentCartDrawer.open = true;
      } catch {
        currentCartDrawer.setAttribute('open', '');
      }

      if (!currentCartDrawer.hasAttribute('open')) {
        currentCartDrawer.setAttribute('open', '');
      }
    };

    try {
      if (notification) {
        notification.hidden = true;
      }
    } catch {
      notification?.setAttribute('hidden', '');
    }

    queueMicrotask(openCart);

    try {
      if (sourceDrawer && sourceDrawer !== cartDrawer) {
        sourceDrawer.open = false;
      }
    } catch {
      sourceDrawer?.removeAttribute('open');
    }

    requestAnimationFrame(openCart);
  }, true);
})();
